import { defineMessages } from "react-intl";

const messages = defineMessages({
  column: {
    defaultMessage: "Columns",
    id: "uqxjSR",
    description: "column picker section header",
  },
  custom: {
    id: "rHQmCt",
    defaultMessage: "Custom",
    description: "column picker section header",
  },
  categories: {
    id: "4ELCCk",
    defaultMessage: "Categories",
    description: "column picker section default header",
  },
  searchForColumns: {
    id: "Xsh2Pa",
    defaultMessage: "Search for columns",
    description: "column picker search input placeholder",
  },
  noResultsFound: {
    id: "cPAc45",
    defaultMessage: "No results found",
    description: "column picker search no results message",
  },
});

export default messages;
